import { Users } from "lucide-react";
import React from "react";

import { IgButton, IgPaper, IgTypography } from "@intelligems/ig-theme";
import { Grid, useTheme } from "@mui/material";
import { AnalyticsSummary } from "@src/features/ai/components/usages/AnalyticsSummary";
import { community } from "@src/utils/linkSheet";
import { openNewTab } from "@src/utils/openNewTab";

const CommunityCard = () => {
  const theme = useTheme();
  return (
    <Grid container direction="column" rowSpacing={4}>
      <Grid item>
        <IgTypography variant={"h2"} fontWeight={"fontWeightMedium"}>
          Discover Our Community
        </IgTypography>
      </Grid>

      <Grid item>
        <IgPaper
          sx={{
            padding: "10px 30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            minHeight: "80px",
          }}
          onClick={() => openNewTab(community)}
        >
          <Grid container alignItems="center" spacing={2}>
            <Grid item>
              <Users />
            </Grid>
            <Grid item xs>
              <IgTypography fontWeight={"fontWeightMedium"} variant={"h3"}>
                Community{" "}
              </IgTypography>
              <IgTypography sx={{ marginTop: "8px", marginLeft: "5px" }}>
                Join our community to share ideas, get feedback, and learn from
                other users!
              </IgTypography>
            </Grid>
            <Grid item>
              <IgButton
                variant={"contained"}
                onClick={() => openNewTab(community)}
              >
                Explore Now
              </IgButton>
            </Grid>
          </Grid>
        </IgPaper>
      </Grid>
    </Grid>
  );
};

export default CommunityCard;
